module.exports = __webpack_public_path__ + "static/matilda_weekend-efa7fd3eee0e9b72436b15aa63bbe815.jpg";